module.exports = __webpack_public_path__ + "img/T_RoomManagement_RGB.svg";